import { createFocusTrap } from 'focus-trap'
import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

const sleep = ms => new Promise(r => setTimeout(r, ms))
const toggleTransitionDuration = 150

class NavigationDropdownExpanderComponent extends Component {
  init() {
    this.button = this.element.querySelector('.navigation-dropdown-expander__button')

    if (!this.button) {
      return
    }

    this.regionId = this.button.getAttribute('aria-controls')

    if (!this.regionId) {
      return
    }

    this.region = this.element.querySelector(`#${this.regionId}`)

    if (!this.region) {
      return
    }

    this.regionIsOpen = false
    this.contentContainers = [...document.querySelectorAll('.container--content, .container--footer')]
    this.firstFocusableItem = this.region.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
    this.backdrop = this.element.querySelector('.navigation-dropdown-expander__popout-backdrop')

    this.focusTrap = createFocusTrap(this.region, {
      onActivate: () => {},
      onDeactivate: () => {
        //this.toggleRegion(true)
        this.button?.focus()
      },
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: true,
      initialFocus: this.firstFocusableItem || false,
    })

    this.button.addEventListener('click', async () => await this.toggleRegion())
    window.addEventListener('resize', () => !this.regionIsOpen || this.toggleRegion(true), { passive: true })
    window.addEventListener('scroll', () => !this.regionIsOpen || this.toggleRegion(true), { passive: true })
    window.addEventListener('close-navigation-dropdown-expanders', () => this.toggleRegion(true))
    this.backdrop?.addEventListener('click', () => this.toggleRegion(true))
  }

  async toggleRegion(forceClose = false) {
    if (!this.button || !this.region) {
      return
    }

    if (this.regionIsOpen || forceClose) {
      this.regionIsOpen = false
      this.focusTrap?.deactivate()
      this.region.setAttribute('hidden', 'hidden')
      this.region.setAttribute('inert', 'inert')
      this.button.setAttribute('aria-expanded', false)
      this.contentContainers.forEach(container => container.removeAttribute('inert'))
    } else {
      await this.hideOtherRegions()

      this.contentContainers.forEach(container => container.setAttribute('inert', 'inert'))
      this.region.removeAttribute('inert')
      this.region.removeAttribute('hidden')
      this.button.setAttribute('aria-expanded', true)
      this.focusTrap?.activate()
      this.regionIsOpen = true
    }
  }

  async hideOtherRegions() {
    const otherRegions = [...this.element.parentNode.querySelectorAll('.navigation-dropdown-expander__popout:not([hidden])')].filter(child => child !== this.region)

    if (!otherRegions.length) {
      return
    }

    otherRegions.forEach(region => document.querySelector(`[aria-controls="${region.id}"]`)?.click())
    await sleep(toggleTransitionDuration)
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'navigation-dropdown-expander', NavigationDropdownExpanderComponent))
